import styled, { css } from 'styled-components';
import { HeadingBase } from 'elements/Heading/styled';
import {
  colors,
  duration,
  ease,
  elevation,
  themed,
  isDefaultThemeMode,
} from 'core/theme';
import { CardBase } from './';


export const StyledHeading = HeadingBase.extend`
  color: currentColor;
`;

export const Group = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & > *:not(i) {
    margin: 0;
  }
`;

const backgroundColor = (props) => {
  const defaultThemed = Object.assign({}, colors.lightThemed, {
    light: colors.HIGHLIGHT,
  });
  return themed(defaultThemed);
};

const applyBoxShadow = (props) => {
  if (isDefaultThemeMode(props)) {
    return css`
      box-shadow: ${elevation.Z0};
      transition: box-shadow ${duration.fast} ${ease.standard};
      will-change: box-shadow;

      &:hover {
        box-shadow: ${elevation.Z8};
      }
    `;
  }
};

const hoverColor = (props) => (
  isDefaultThemeMode(props) ? colors.accent : colors.background
);

const arrowColor = (props) => (
  isDefaultThemeMode(props) ? '#CCCCCC' : colors.accent
);

const StyledLinkCard = CardBase.extend`
  background-color: ${backgroundColor};
  ${applyBoxShadow};
  color: ${colors.text};
  display: flex;
  align-items: center;
  min-height: 64px;
  padding: 16px;

  & i {
    margin-left: 16px;

    & > svg {
      color: ${arrowColor};
    }
  }

  &:hover {
    &,
    & i > svg {
      color: ${hoverColor};
    }
  }

  @media print {
    &:after {
      padding: 0;
    }
  }
`;

export default StyledLinkCard;



// WEBPACK FOOTER //
// ./src/elements/Card/styled/StyledLinkCard.js